import { FETCH_CONVERSATION_ATTACHMENTS } from 'modules/chat/actionTypes';
import simpleSearchReducers from 'modules/global/reducers/simpleSearchReducer';

import mediaListFilters from './filters';

/** @typedef {{ filters: Record<string, string> } & import("modules/global/reducers/simpleSearchReducer").SimpleSearchReducer} ConversationMediaListReducer */

export default simpleSearchReducers(FETCH_CONVERSATION_ATTACHMENTS, undefined, {
  filters: mediaListFilters,
});
